// 13331166589: global admin switch; missing keeps existing recorder behavior.
export const SIGNING_FACE_CAMERA_ENV_KEY = 'signingFaceCameraEnabled'

export const signingFaceCameraEnabled = (raw: unknown): boolean => {
  if (raw === false) return false
  if (typeof raw !== 'string') return true
  return !['no', 'off', 'false'].includes(raw.trim().toLowerCase())
}
